/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import {
  deleteDoc,
  deleteField,
  doc,
  DocumentReference,
  FieldValue,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import { store } from "@/store";
import { BotStore } from "@/store/constants";
import { IBlock } from "@chatcaptain/types/chatbot";

const chatbotId = store.getters[BotStore.Getters.GET_ID];

const getBlockReference = (
  flowId: string,
  blockId: string
): DocumentReference => {
  return doc(
    getFirestore(),
    "dialogs/" + chatbotId + "/flows/" + flowId + "/blocks/" + blockId
  );
};

export const updateBlock = async (
  flowId: string,
  blockId: string,
  updateData: Partial<IBlock>
) => {
  const deleteFields = {} as { user_input: FieldValue };
  if (updateData.user_input && updateData.user_input == null)
    deleteFields.user_input = deleteField();
  Object.keys(updateData).forEach((key) => {
    if (updateData[key] == undefined) updateData[key] = deleteField();
  });
  await updateDoc(getBlockReference(flowId, blockId), {
    ...updateData,
    ...deleteFields,
  });
};

export const deleteBlock = async (flowId: string, blockId: string) => {
  await deleteDoc(getBlockReference(flowId, blockId));
};
